export const diaChiNhanHang = {
  sections: {
    list: { title: '配送信息' },
  },
  fields: {
    customerId: '客户编码',
    customer: '客户',
    receiverName: '收货人',
    phone: '收货人电话',
    address: '配送地址',
    region: '坊 / 省',
    province: '省/市',
    ward: '乡/镇/坊',
    viDo: '纬度',
    kinhDo: '经度',
    coords: 'GPS坐标',
    coordsFormat: '纬度: {viDo} · 经度: {kinhDo}',
    default: '默认配送',
    defaultYes: '默认',
    defaultNo: '—',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
  },
  filter: {
    searchPlaceholder: '收货人、电话或配送地址',
    customerPlaceholder: '搜索客户…',
    defaultAll: '全部',
    defaultYes: '仅默认',
    defaultNo: '非默认',
  },
  placeholders: {
    provinceEmpty: '— 选择省/市 —',
    wardEmpty: '— 选择坊/乡 —',
    addressSearch: '至少输入 2 个字符搜索地址',
    addressNoOptions: '无地址建议',
    viDo: '例: 10.7769',
    kinhDo: '例: 106.7009',
  },
  titles: { add: '新增配送信息', edit: '编辑配送信息' },
  inline: {
    itemTitle: '配送信息',
  },
  messages: {
    noData: '暂无数据',
    loadError: '加载失败',
    invalidContext: 'URL 中需要有效的客户 ID。',
    customerRequired: '请选择客户。',
    createSuccess: '已创建配送信息',
    updateSuccess: '已更新配送信息',
    deleteSuccess: '已删除配送信息',
    notFound: '未找到配送信息',
    confirmDelete: '删除配送信息 «{name}»？',
    listSummary: '共 {count} 条配送信息',
  },
}
